import { EMAIL_KIND_REVIEW_CHECK, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export type ReviewCheckEmailModalMode = 'status_transition' | 'email_only';

export interface ReviewCheckEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
  mode: ReviewCheckEmailModalMode;
  intendedState?: string;
}

export {
  projectReviewDeadlineToDisplay,
  reviewDeadlineDisplayToApi,
} from '@/utils/emailDateUtils';

export function ReviewCheckEmailModal({
  open,
  onClose,
  project,
  mode,
  intendedState,
}: ReviewCheckEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_REVIEW_CHECK}
      modalTitle={`Проверка: ${project.name ?? 'Проект'}`}
      requireNewState={mode === 'status_transition'}
      newStateWhenSaving={mode === 'status_transition' ? intendedState : undefined}
    />
  );
}
